import { FC } from 'react';
import { BsFilePdf, BsFileWord } from 'react-icons/bs';
import { MBox, MIcon, MTooltip } from '../../../../../components/Monetize';
import { getDocumentFormatLabel } from '../../../../../utils/download';

export const DocumentFormatTag: FC<{ mediaType?: string | null }> = ({
  mediaType,
}) => {
  const isWordDoc = getDocumentFormatLabel(mediaType) === 'WORD';
  const label = isWordDoc ? 'Word document' : 'PDF document';

  return (
    <MTooltip label={label} placement="top">
      <MBox display="inline-flex" role="img" aria-label={label} flexShrink={0}>
        <MIcon
          as={isWordDoc ? BsFileWord : BsFilePdf}
          boxSize={4}
          color="fg.muted"
        />
      </MBox>
    </MTooltip>
  );
};
